<template>
  <div
    v-cloak
    :class="`${!$device.isDesktop ? 'mobile' : '' }`"
  >
    <Mobile v-if="!$device.isDesktop" />

    <nuxt />

    <nuxt-link v-if="$route.name !== 'scan' && $route.name !== 'signin'" to="/scan" class="scan-btn">
      <img src="/static_files/icons/scan.png" alt="Scan">
      <!-- <nuxt-img
        src="/static_files/icons/scan.png"
        alt="Scan"
        format="png"
        width="24"
        height="24"
        quality="100"
      /> -->
      Сканировать чек
    </nuxt-link>

    <div
      v-if="user && $route.name !== 'scan'"
      @click="showUserEmail = !showUserEmail"
      class="profile-btn"
      :class="{ active: showUserEmail }"
    >
      <transition name="toLeftSign">
        <div v-if="showUserEmail" class="profile">
          <span>
            {{ user.username }}
          </span>
          <span @click="logout" class="exit">
            Выйти
          </span>
        </div>
      </transition>
    </div>

    <transition name="toTop">
      <!-- <Error :error="{ msg: '12321321321321' }" /> -->
      <Error v-if="error" :error="error" />
    </transition>

    <div v-if="gloading" class="gloading">
      <img src="/static_files/icons/Blocks-1s-200px.gif" alt="">
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import global from '~/mixins/global.js'
Vue.mixin(global)

export default {
  // middleware: 'userauth',
  components: {
    Mobile: () => import('~/components/Mobile.vue'),
    Error: () => import('~/components/Error.vue'),
  },
  // watch: {
  //   changeRoute() {}
  // },
  computed: {
    ...mapState(['error', 'user', 'gloading']),
    changeRoute() {
      return this.$route.fullPath
    }
  },
  data() {
    return {
      showUserEmail: false,
    }
  },
  // mounted() {
  // },
  methods: {
    async logout() {
      await this.$axios.get('/api/auth/logout')
      this.$store.commit('setUser', null)
      location.reload()
    },
  },
}
</script>

<!-- <style src="~/assets/main.styl" lang="stylus" /> -->
